import { render, staticRenderFns } from "./learningDetails.vue?vue&type=template&id=fec826c8&scoped=true&"
import script from "./learningDetails.vue?vue&type=script&lang=js&"
export * from "./learningDetails.vue?vue&type=script&lang=js&"
import style0 from "./learningDetails.vue?vue&type=style&index=0&id=fec826c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec826c8",
  null
  
)

export default component.exports